export default __webpack_public_path__ + "static/media/4.f785ca9d.jpg";